import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import {
  isPrivateBulletinPlanLoadingModalSelector,
} from 'store/state/app/private-user-monetization/selectors';
import Modal from 'ds/components/modal';
import { noop } from 'lodash';
import Spinner from 'components/widget/prices/prices-table/tables/history/affiliation/Spinner';
import styled from '@emotion/styled';


const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${theme.spacing(4)} ${theme.spacing(3)}`,
}));

export const PrivateBulletinPlanLoadingModalBase: React.FC<{ isOpen: boolean }> = props => {
  const { isOpen } = props;

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={noop}
      mobileModalPositionBottom
      hideCloseButton
    >
      <Wrapper>
        <Spinner />
      </Wrapper>
    </Modal>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isPrivateBulletinPlanLoadingModalSelector(state),
});

export const PrivateBulletinPlanLoadingModal = connect(mapStateToProps)(PrivateBulletinPlanLoadingModalBase);
